<div class="te-col-center">

    <div style="max-width: 800px; min-width: 50%;  padding: 0;">

        <h2  class="te-col-center" mat-dialog-title>{{'HelpDeskText3' | translate}}</h2>

        <mat-card class="te-col-center te-panel te-form-900" style="width:100%;  padding: 3px;margin:0 auto;">

            <div class="te-row-end" style="font-style:italic;">* {{'LastUpdated' | translate}} <b> {{  lastUpdatedDate | date:'MM/dd/yyyy'}}</b> </div>
            <br />

            <table mat-table [dataSource]="dataSource" style="padding:0px; width:100%;">

                <!--- Note that these columns can be defined in any order. The actual rendered columns are set as a property on the row definition" -->
                <!-- Country Column -->
                <ng-container matColumnDef="u_country">
                    <th mat-header-cell *matHeaderCellDef><h4><span> <b>{{'Country' | translate}}</b></span></h4></th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.u_country}}</span>
                    </td>
                </ng-container>

                <!-- SupportDesk Column -->
                <ng-container matColumnDef="u_support_desk">
                    <th mat-header-cell *matHeaderCellDef><h4><span><b> {{'SupportDesk' | translate}}</b> </span></h4></th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.u_support_desk}}</span>
                    </td>
                </ng-container>
                <!-- PhoneNo Column -->
                <ng-container matColumnDef="u_phone_number">
                    <th mat-header-cell *matHeaderCellDef><h4><span><b> {{'PhoneNo' | translate}} </b> </span></h4></th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.u_phone_number}}</span>
                    </td>

                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-progress-bar *ngIf="loadingStatus" mode="indeterminate"></mat-progress-bar>
           
        </mat-card>

    </div>

</div>